import { Fragment, ReactNode } from 'react';

/**
 * 解析 Markdown 加粗格式 (**text**) 并渲染为 React 元素
 * @param tip - 包含 **加粗** 格式的文本
 * @returns React 节点数组
 */
export const formatTip = (tip: string): ReactNode[] => {
  const parts = tip.split(/(\*\*.*?\*\*)/g);
  return parts.map((part, index) => {
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={index}>{part.slice(2, -2)}</strong>;
    }
    return <Fragment key={index}>{part}</Fragment>;
  });
};
